import { useState } from 'react';
import { isAddMode, isWriteMode, ViewMode } from '@/lib/helpers';

const useViewMode = (initialState: ViewMode = 'view') => {
  const [mode, setMode] = useState<ViewMode>(initialState);

  return { mode, setMode, inWriteMode: isWriteMode(mode), inAddMode: isAddMode(mode) };
};

export default useViewMode;
